<template>
  <div class="page">
    <v-layout>
      <v-flex xs3>
        <div class="title-header">{{ this.$t('smsQueryTitle') }}</div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs6 sm3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon class="icon">$finance</v-icon>
          </v-flex>
          <router-link to="query">
            <div>{{ this.$t('smsQueryText') }}</div></router-link
          >
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs3>
        <div class="title-header">{{ this.$t('smsSendTitle') }}</div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs6 sm3>
        <div class="item-cell">
          <v-flex xs12>
            <v-icon class="icon">$apps</v-icon>
          </v-flex>
          <router-link to="send">
            <div>{{ this.$t('smsSendText') }}</div></router-link
          >
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.page {
  margin-top: 72px;
  text-align: center;
}
.item-cell {
  border: 1px solid #1cade4;
  margin-left: 30px;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 60px;
  border-radius: 10px;
  padding-top: 60px;
}
.item-cell :hover {
  cursor: pointer;
}
.v-icon {
  font-size: 20px !important;
  line-height: 20px !important;
}
.icon {
  font-size: 58px !important;
  margin-bottom: 20px;
  color: #1cade4 !important;
}
.title-header {
  text-align: left;
  border-left: 5px solid #1cade4;
  margin-left: 30px;
  margin-top: 30px;
  padding-left: 10px;
  font-size: 16px;
  color: #1cade4;
}
</style>
<script>
import { mapState } from 'vuex'

export default {
  components: {},
  data: () => ({}),
  computed: {
    ...mapState({
      base: (state) => state.base,
    }),
  },
  watch: {},
  methods: {},
  mounted() {},
}
</script>
<i18n>
{
  "en": {    
    "smsQueryTitle": "SMS Query",
    "smsQueryText": "Query",
    "smsSendTitle": "SMS Send",
    "smsSendText": "Send"
  }
}
</i18n>
